import React, { useState, useMemo, useEffect } from "react";
import { List, Typography, Space, Input, Button, Row, Col } from "antd";
import MetaCard from "../Card/MetaCard ";
import axios from "axios";

const MetaList = () => {
  const [metadataList, setMetadataList] = useState([]);
  const [newMetadataName, setNewMetadataName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const fetchMetaData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/metadata/getMetadata`
      );
      const data = response.data;
      const transformedData = data.map((metadata) => ({
        id: metadata._id,
        name: metadata.name || "",
        genres: metadata.genresIncluding
          ? metadata.genresIncluding.map((genre) => genre.name)
          : [],
        externalGenres: metadata.externalGenres,
      }));
      setMetadataList(transformedData);
    } catch (error) {
      console.error("Error fetching metadata:", error);
    }
  };

  useEffect(() => {
    fetchMetaData();
  }, []);

  const handleUpdateMetadata = async (metadataId, updateData) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_SERVER_URL}/metadata/updateMetadata/${metadataId}`,
        updateData
      );
      fetchMetaData();
    } catch (error) {
      console.error("Error updating metadata:", error);
    }
  };

  const handleAddMetadata = async () => {
    if (newMetadataName.trim() !== "") {
      try {
        await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/metadata/createMetadata`,
          {
            name: newMetadataName,
          }
        );
        fetchMetaData();
        setNewMetadataName("");
      } catch (error) {
        console.error("Error adding metadata:", error);
      }
    }
  };

  const handleDeleteMetadata = async (metadataId) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/metadata/deleteMetadata/${metadataId}`
      );
      fetchMetaData();
    } catch (error) {
      console.error("Error deleting metadata:", error);
    }
  };

  const filteredMetadata = useMemo(() => {
    return metadataList.filter((metadata) => {
      const nameToLowerCase = (metadata.name || "").toLowerCase();
      return nameToLowerCase.includes(searchTerm.toLowerCase());
    });
  }, [metadataList, searchTerm]);

  return (
    <div>
      <Typography.Title level={3}>Meta List</Typography.Title>

      <Space direction="vertical" style={{ marginBottom: 16, width: "100%" }}>
        <Row justify="space-between" align="middle">
          <Col>
            <Space>
              <Input
                placeholder="Meta"
                value={newMetadataName}
                onChange={(e) => setNewMetadataName(e.target.value)}
              />
              <Button type="primary" onClick={handleAddMetadata}>
                Add Meta
              </Button>
            </Space>
          </Col>
          <Col>
            <Input
              placeholder="Search Meta"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>
        </Row>
      </Space>

      <List
        grid={{ gutter: 16, column: 3 }}
        dataSource={filteredMetadata}
        renderItem={(metadata) => (
          <List.Item key={metadata.id}>
            <MetaCard
              metadata={metadata}
              onUpdateMetadata={handleUpdateMetadata}
              onDeleteMetadata={handleDeleteMetadata}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default MetaList;
